import React from "react";
import "./RibbonTabs.css";
import useDeviceInfo from "../hooks/useDeviceInfo";

import solar_power_img from '../assets/material_icons/solar_power.svg';
import roof_img from '../assets/material_icons/roof.svg';
import grid_img from '../assets/material_icons/grid_4x4.svg';
import offset_img from '../assets/material_icons/offset.svg';
import table_rows_img from '../assets/material_icons/table_rows.svg';
import table_img from '../assets/material_icons/table.svg';
import air_img from '../assets/material_icons/air.svg';


const iconMap = {
  main: roof_img,
  sub: solar_power_img,
  column: offset_img,
  layout: grid_img,
  boq: table_img,
  air: air_img,
};

const RibbonTabs = ({ tabs, activeTab, onTabChange }) => {
    const { deviceType } = useDeviceInfo();
    const isPhone = deviceType === "phone";
  
    return (
        <>
      <div className={`tabs ${deviceType}`}>
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.value;
          const imgSrc = iconMap[tab.value];
          return (
            <div
              key={tab.value}
              className={`tab  ${deviceType} ${isActive ? "active" : ""} ${index === 0 ? "first" : ""} ${
                index === tabs.length - 1 ? "last" : ""
              }`}
              onClick={() => onTabChange(tab.value)}
            >
              {isPhone && imgSrc && (
                <img
                  src={imgSrc}
                  alt={tab.label}
                  className="tab_icon"
                />
              )}
              {!isPhone && tab.label}
            </div>
          );
        })}
      </div>

      </>
  );
};

export default RibbonTabs;